import React from "react";
import { AttachMoney, InsertLink, Delete, LiveTv } from "@material-ui/icons";
import * as S from "./styles";
import { useTranslation } from "react-i18next";
import { useMainState } from "modules/app/contexts";
import { mapCountryCurrency } from "modules/app/utils";

function ProductItem({ product, handleClick, handleRemove }) {
  const { t } = useTranslation(["Customer"]);
  const { company, channels, leadSources } = useMainState();
  const currency = mapCountryCurrency[company?.locale || "pt-BR"];
  const { channel_id, lead_source_id } = product;

  const channel = channels?.find((c) => c.id == channel_id);
  const leadSource = leadSources?.find((l) => l.id == lead_source_id);

  return (
    <S.Container>
      <S.Content>
        <S.Title>
          {product.reference_code ? `[${product.reference_code}] ` : ""}
          {product.name || t("details.products.withoutName")}:
        </S.Title>
        <S.InfoContent>
          <S.ButtonContent onClick={() => handleClick && handleClick()}>
            <S.Information>
              <S.MoneyIcon>
                <AttachMoney className="icon" fontSize="small" />
                {product.price
                  ? `${currency} ${product.price}`
                  : t("details.products.notFound")}
              </S.MoneyIcon>

              <S.ChainIcon>
                <InsertLink className="icon" fontSize="small" />

                {!!product.url ? (
                  <S.Anchor
                    target="_blank"
                    rel="noopener noreferrer"
                    href={product.url}
                  >
                    {product.url}
                  </S.Anchor>
                ) : (
                  t("details.products.notFound")
                )}
              </S.ChainIcon>

              <S.LiveTvIcon className="price">
                <LiveTv className="icon" fontSize="small" />

                {channel || leadSource
                  ? `${channel?.name || ""} ${
                      leadSource?.name ? "/ " + leadSource.name : ""
                    }`
                  : t("details.products.notFound")}
              </S.LiveTvIcon>
            </S.Information>
          </S.ButtonContent>
          <S.DeleteBtn onClick={() => handleRemove(product)}>
            <Delete
              className="delete"
              color={channel?.name === "Internet" ? "disabled" : "secondary"}
            />
          </S.DeleteBtn>
        </S.InfoContent>
      </S.Content>
    </S.Container>
  );
}

export default ProductItem;
